// Simple Button component without Radix dependencies
import React from 'react';

export function Button({ 
  children, 
  variant = 'default', 
  className = '', 
  onClick,
  disabled = false,
  type = 'button',
  ...props 
}) {
  const baseClasses = 'inline-flex items-center justify-center rounded-xl text-sm font-medium ring-offset-background transition-all duration-300 transform hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:shadow-lg';
  
  const variants = {
    default: 'bg-amber-900 text-white hover:bg-amber-800',
    secondary: 'bg-amber-100 text-amber-900 hover:bg-amber-200',
    ghost: 'hover:bg-amber-100 hover:text-amber-900',
    outline: 'border border-amber-300 bg-background hover:bg-amber-50',
    destructive: 'bg-red-600 text-white hover:bg-red-700',
    success: 'bg-green-600 text-white hover:bg-green-700'
  };
  
  const sizes = {
    default: 'h-10 px-4 py-2',
    sm: 'h-9 rounded-xl px-3',
    lg: 'h-11 rounded-xl px-8'
  };

  return (
    <button
      type={type}
      className={`${baseClasses} ${variants[variant]} ${sizes.default} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;